import React, {useCallback, useEffect, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import TrendingDestinationsUI from '../../../../stories/components/hotels/HomePage/TrendingDestinationsUI/TrendingDestinationsUI';
import {trendingDestinationsSelectorFn} from '../destinations-redux/selectors';
import {useNavigateForSearchWidget} from '../../../hooks/useNavigateForSearchWidget';
import {IUpdate_Query, UPDATE_QUERY} from '@stencil/hotels-common-reducer/src/types';
import {fetchDestinationsThunk} from '../destinations-redux/thunks';
import {pushga} from 'ga-utils';
import {commonSelectorFn} from '@stencil/hotels-common-reducer/src/selectors';
import {HomePageGAEvents} from '../../../config/ga-config';
import {countryTextMap} from '../../../../shared/config/app-config';

const TrendingDestinations = () => {
  const dispatch = useDispatch();
  const {
    trendingCityList,
    domesticTrendingCityList,
    internationalTrendingCityList,
    text,
    isTrendingDestinationsLoading,
    trendingDestinationsFromState,
  } = useSelector(trendingDestinationsSelectorFn);

  const {country} = useSelector(commonSelectorFn);

  let cityList = [];
  if (country === '') {
    cityList = trendingCityList;
  } else if (country === countryTextMap.india.key) {
    cityList = domesticTrendingCityList;
  } else if (country === countryTextMap.international.key) {
    cityList = internationalTrendingCityList;
  }

  const topDestinationsDataFromStateRef = useRef(trendingDestinationsFromState);

  const fetchTrendingDestinationsThunkCaller = useCallback(() => {
    return dispatch(fetchDestinationsThunk());
  }, [dispatch]);

  useEffect(() => {
    if (
      topDestinationsDataFromStateRef.current &&
      Object.keys(topDestinationsDataFromStateRef.current).length <= 0
    ) {
      fetchTrendingDestinationsThunkCaller();
    }
  }, []);

  useEffect(() => {
    topDestinationsDataFromStateRef.current = trendingDestinationsFromState;
  }, [trendingDestinationsFromState]);

  const {onSearch} = useNavigateForSearchWidget();

  const updateQueryCaller = useCallback(
    (actionData: IUpdate_Query['actionData']) => {
      return dispatch({type: UPDATE_QUERY, actionData});
    },
    [dispatch],
  );

  const clickHandler = item => {
    if (!item || !item.go_data) return;

    updateQueryCaller({
      destination: {_id: item?.go_data?.oid, n: item?.go_data?.n},
      country: item?.cnt_code || '',
    });
    onSearch({exclusions: ['gostays']});
  };

  if (isTrendingDestinationsLoading || !trendingDestinationsFromState) return null;

  const homePageClicksGAHandler = val => {
    pushga({
      eventCategory: HomePageGAEvents.hotelHomePageClicks.category,
      eventAction: HomePageGAEvents.hotelHomePageClicks.action.trendingDestinationsClicked,
      eventLabel: val,
    });
  };

  return (
    <>
      {!!cityList.length && (
        <TrendingDestinationsUI
          clickHandler={clickHandler}
          trendingCityList={cityList}
          text={text}
          homePageClicksGAHandler={homePageClicksGAHandler}
        />
      )}
    </>
  );
};

export default TrendingDestinations;
